module.exports = __webpack_public_path__ + "img/reply-all.551de4f3.svg";